import React, { useRef, useEffect, useState } from 'react';
import { Button, Box, ButtonPropsSizeOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';

export interface ButtonItem {
  id: string;
  label: string;
}

interface ButtonGroupListProps {
  size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>
  buttons: ButtonItem[];
  disabled?: boolean;
  onClick: (id: string) => void;
}

const ButtonGroupList: React.FC<ButtonGroupListProps> = ({ buttons, onClick, size, disabled = false }) => {
  const refs = useRef<(HTMLButtonElement | null)[]>([]);
  const [maxWidth, setMaxWidth] = useState<number | null>(null);

  useEffect(() => {
    if (refs.current.length) {
      const widths = refs.current.map((ref) => ref?.scrollWidth || 0);
      setMaxWidth(Math.max(...widths));
    }
  }, [buttons]);

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {buttons.map((btn, index) => (
        <Button
          disabled={disabled}
          key={btn.id}
          size={size}
          ref={(el) => (refs.current[index] = el)}
          onClick={() => onClick(btn.id)}
          sx={{
            width: maxWidth ?? 'auto',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textTransform: 'none',
            flexShrink: 0,
            backgroundColor: '#821818',
            color: 'white',
            fontWeight: 600,
            fontSize: '14px',
            '&.Mui-disabled': {
              backgroundColor: '#e0e0e0',
              color: '#9e9e9e',
            },
            '&: hover': {
                backgroundColor: '#821818',
                boxShadow: 'none'
            },
            borderRadius: 'unset'
          }}
        >
          {btn.label}
        </Button>
      ))}
    </Box>
  );
};

export default ButtonGroupList;